import { connect } from 'react-redux'
import RolesPublished from 'modules/Report/Partials/RolesPublished/index.js'
import {
  cityDetails,
  tierDetails,
  getRolePublishedToCollege,
} from 'modules/Report/action.js'
import reportSelectors from 'modules/Report/selectors.js'
import authSelector from 'modules/Auth/selectors'
const mapStateToProps = state => ({
  cityData: reportSelectors.getCityData(state),
  tierData: reportSelectors.getTierData(state),
  rolesPublishedData: reportSelectors.getRolesPublishedData(state),
  excelDataForReport: reportSelectors?.excelData(state),
  corporateData: authSelector.getCorporateData(state),
})

const mapDispatchToProps = {
  cityDetails,
  tierDetails,
  getRolePublishedToCollege,
}

export default connect(mapStateToProps, mapDispatchToProps)(RolesPublished)
